import { Shipment } from "@domain/shipment";
import { PurchaseOrderItem } from "./PurchaseOrderItem";
import { Product } from "@domain/product/models/Product";
import { Supplier } from "@domain/suppliers";
import { PurchaseOrder } from "./PurchaseOrder";

export class POItemGroup {
    id: string;
    name: string;
    items: PurchaseOrderItem[];

    constructor(id: string, name: string, items: PurchaseOrderItem[]) {
        this.name = name;
        this.items = items;
        this.id = id;
    }
}

export class POItemShipmentGroup extends POItemGroup {
    shipment?: Shipment;

    constructor(id: string, name: string, items: PurchaseOrderItem[], shipment?: Shipment) {
        super(id, name, items);
        this.shipment = shipment;
    }
}

export class POItemProductGroup extends POItemGroup {
    product: Product;

    constructor(id: string, name: string, items: PurchaseOrderItem[], product: Product) {
        super(id, name, items);
        this.product = product;
    }
}

export class POItemSupplierGroup extends POItemGroup {
    supplier: Supplier;

    constructor(id: string, name: string, items: PurchaseOrderItem[], supplier: Supplier) {
        super(id, name, items);
        this.supplier = supplier;
    }
}

export class POItemPurchaseOrderGroup extends POItemGroup {
    purchaseOrder: PurchaseOrder;

    constructor(id: string, name: string, items: PurchaseOrderItem[], purchaseOrder: PurchaseOrder) {
        super(id, name, items);
        this.purchaseOrder = purchaseOrder;
    }
}

// Union type for all group types
export type POItemGroups = POItemShipmentGroup | POItemProductGroup | POItemSupplierGroup | POItemPurchaseOrderGroup;